import React, { useMemo, useState } from "react";
import PlanDetails from "./planDetails";
import FeatureDetails from "./FeatureDetails";
import DesignerDetails from "./DesignerDetails";
import DesignerPlan from "./DesignerPlan";

const ImgReroute = ({ routeType }) => {
  const [selectedTab, setSelectedTab] = useState("customer");
  const isAdmin = useMemo(()=> {
    let arr = JSON.parse(localStorage.getItem("permissions"));
    if (arr.includes("super.ADMIN")) return true
  }, [])
  
  const changeTab = (e) => {
    if (e.target.tagName === "LI") {
      document.querySelectorAll("#tab li").forEach((li) => li.classList.remove("tab-selected"));
      e.target.classList.add("tab-selected");

      if (selectedTab !== e.target.id) {
        setSelectedTab(e.target.id);
      }
    }
  };


  const planMap = {
    designer: <DesignerPlan/>,
    customer: <PlanDetails />,
  };

  const featureMap = {
    designer: <DesignerDetails />,
    customer: <FeatureDetails />,
  };
  if(!isAdmin) return (<div className="col-12 " style={{ color: "#01579B" }}>
      <div className="card flex flex-column align-items-center justify-content-center dijon-ivory" style={{ height: "60vh"}}>
          <span className="fa-solid fa-circle-info" style={{ fontSize: "3rem" }}></span>
          <h3 className='font-larken'>You are not authorized to access this page</h3>
      </div>
  </div>)
  else return (
    <div className="col-12">
      <div className="col-12 custom-tabview">
        <ul id="tab" onClick={changeTab}>
          <li className={`text-2xl ${selectedTab === "customer" ? "tab-selected" : ""}`} id="customer">
            {routeType === "plan" ? "Customer Plans" : "Customer Features"}
          </li>
          <li className={`text-2xl ${selectedTab === "designer" ? "tab-selected" : ""}`} id="designer">
            {routeType === "plan" ? "Designer Plans" : "Designer Features"}
          </li>
        </ul>
        <div className="overflow-y-auto mt-0">{routeType === "plan" ? planMap[selectedTab] : featureMap[selectedTab]}</div>
      </div>
    </div>
  );
};

export default ImgReroute;